import {WaterMarkModule} from '@gongxigames/framework/slot/modules/watermark';

export class WaterMarkModuleFullscreen extends WaterMarkModule {
    protected setupViews(): void {
        super.setupViews();

        this.view.isFullscreen = true;
    }
}
